import { Button } from '@/components/ui/button';
import { SessionStatusChangeModal } from './session-status-change-modal';
import { AdminSession, SessionStatus } from '@airreading/common/data';

interface SessionCompleteButtonProps {
  session: AdminSession;
  trigger?: React.ReactNode;
}

export const SessionCompleteButton = ({ session, trigger }: SessionCompleteButtonProps) => {
  if (session.status === SessionStatus.cancelled) {
    return null;
  }

  return (
    <SessionStatusChangeModal
      sessions={[session]}
      trigger={
        trigger || (
          <Button variant="outline" className="bg-slate-100 hover:bg-slate-200">
            Complete session
          </Button>
        )
      }
      targetStatus={SessionStatus.completed}
      modalTitle="Complete Session"
      noValidSessionsTitle="Complete Session"
      confirmBtnLabel="Complete session"
      description="Are you sure you want to complete this session?"
      noValidSessionsMessage="This session cannot be completed."
      invalidSessionsMessage="This session cannot be completed."
      buttonVariant="destructive"
    />
  );
};
